import { LoadState } from "../../constants/enums";

export interface INotificationState {
  list: INotification[];
  unreadCount: number;
  totalCount: number;
  loading: LoadState;
  notificationRule: {
    list: INotificationCreateRule[];
    loading: LoadState;
  };
}

export interface INotificationCreateRule {
  module_name: string | null;
  sub_module: string | null;
  action: "CREATE" | "UPDATE";
  primary_key: string;
  table_description: string | null;
  watched_columns: string[];
  recipients: ("created_by_id" | "assigned_to_id")[];
  status: "ACTIVE" | "INACTIVE";
}

export interface INotification {
  notification_code: string;
  entity_id: string;
  type: "CREATE" | "UPDATE";
  module_name: string;
  sub_module_name: string;
  columns: string;
  message: string;
  read_status: string;
  raised_by: string;
}

export const initialNotificationState: INotificationState = {
  list: [],
  unreadCount: 0,
  totalCount: 0,
  loading: LoadState.NotLoaded,
  notificationRule: {
    list: [],
    loading: LoadState.NotLoaded,
  },
};


export const initialNotificationCreateRule: INotificationCreateRule = {
  module_name: null,
  sub_module: null,
  action: "CREATE",
  watched_columns: [],
  recipients: [],
  status: "ACTIVE",
  primary_key: "",
  table_description: null
};